<template lang="pug">
  .collection-tile(
    :is="collection.link ? 'a' : 'div'"
    :href="collection.link"
    :style="collectionTileStyles"
  )
    .collection-tile__content
      span.collection-tile__title {{ collection.title }}
      span.collection-tile__shop-fake-button(
        v-if="collection.link && collection.buttonText"
      ) {{ collection.buttonText }}
</template>

<script>
  export default {
    props: {
      collection: {
        type: Object,
        default: () => ({
          title: String,
          link: String,
          buttonText: String,
          imageSrc: String,
          desktopImageSrc: String,
        }),
      },
    },
    computed: {
      collectionTileStyles() {
        const { imageSrc, desktopImageSrc } = this.collection;

        return {
          backgroundImage: `url("${['mobile', 'tablet'].includes(this.$mq) || !desktopImageSrc ? imageSrc : desktopImageSrc}")`,
        };
      },
    },
  };
</script>

<style lang="scss">
  .collection-tile {
    position: relative;
    padding-bottom: 120%;
    width: 100%;
    background-size: cover;
    background-position: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
  }

  .collection-tile__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    padding: $spacing-unit * 4 $spacing-unit * 2 $spacing-unit * 5;
    width: 100%;
    height: 100%;

    @include desktop-up {
      padding: $spacing-unit * 6 $spacing-unit * 2;
    }
  }

  .collection-tile__title {
    color: $color-green-900;
    font-size: rem(20);
    line-height: rem(26);

    @include desktop-up {
      font-size: rem(26);
    }
  }

  .collection-tile__shop-fake-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 $spacing-unit * 4;
    height: rem(30);
    color: $color-green-900;
    font-size: rem(11);
    text-transform: uppercase;
    background-color: $color-white;
    border: 1px solid transparent;
    border-radius: 28px;
    transition: 0.3s ease all;

    @include desktop-up {
      padding: 0 $spacing-unit * 6;
      height: 40px;
      font-size: rem(14);
    }

    .collection-tile:focus &,
    .collection-tile:hover & {
      color: $color-green-900;
      background-color: $color-green-900;
      border-color: $color-green-900;
    }
  }
</style>
